import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
  addEditServiceValidation,
  errorResponseMessage,
} from "../shared/const.prop";
import ErrorMessage from "../components/ErrorMessage";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { AuthContext } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import info from "../img/info.png";

const AddEditService = ({ editData, isEdit }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      serviceName: editData.serviceName,
      duration: editData.duration,
      amount: editData.amount,
      noOfSessions: editData.noOfSessions,
    },
  });

  const serviceName = watch("serviceName");

  const submitHandler = async (data) => {
    if (data.amount < 0) {
      toast.error("Amount should not be less than zero");
      return;
    }
    if (data.serviceName === "weekly sessions" && data.noOfSessions > 7) {
      toast.error(`You can select upto 7 sessions only`);
      return;
    }
    if (data.serviceName === "monthly sessions" && data.noOfSessions > 30) {
      toast.error(`You can select upto 30 sessions only`);
      return;
    }

    try {
      const addorEditService = await axiosHttp.post(
        isEdit ? `services/${editData.id}` : `services`,
        {
          ...data,
          duration: "60",
          category: "1:1 Call",
        }
      );
      if (addorEditService.status === 201) {
        appContext.updateModalState("fetchService");
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    }
  };

  return (
    <form className="service-card" onSubmit={handleSubmit(submitHandler)}>
      <p className="sub-txt">1:1 Call</p>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="form-group">
            <label>Title</label>
            {/* <input
              type="text"
              class="form-control"
              name="title"
              {...register("serviceName", addEditServiceValidation.serviceName)}
            /> */}
            <select
              className="form-control custom-select"
              id=""
              {...register("serviceName", addEditServiceValidation.serviceName)}
            >
              <option value="Single session">Single session</option>
              <option value="weekly sessions">Weekly sessions</option>
              <option value="monthly sessions">Monthly sessions</option>
            </select>
            <ErrorMessage errors={errors} errorKey="serviceName" />
          </div>
        </div>
        {/* <div className="col-md-12">
          <div className="form-group">
            <label>Custom duration (min) </label>
            <select
              className="form-control custom-select"
              id=""
              {...register("duration", addEditServiceValidation.duration)}
            >
              <option value="30">30 min</option>
              <option value="45">45 min</option>
              <option value="60">60 min</option>
            </select>
            <ErrorMessage errors={errors} errorKey="duration" />
          </div>
        </div> */}
        <div className="col-md-12">
          <div className="form-group">
            <label>Amount</label>
            <div className="input-group prepond-group mb-4">
              <div className="input-group-prepend">
                <span
                  className="input-group-text addon-icon bg-transparent"
                  id="basic-addon1"
                >
                  {/* {symbol ? symbol : "₹"} */}₹
                </span>
              </div>
              <input
                type="number"
                class="form-control"
                inputMode="numeric"
                min="0"
                // max="9999"
                id="myNumberInput"
                name="amount"
                {...register("amount", addEditServiceValidation.amount)}
              />
            </div>
            <ErrorMessage errors={errors} errorKey="amount" />
          </div>
        </div>
        {serviceName !== "Single session" && serviceName !== undefined && (
          <div className="col-md-12">
            <div className="form-group">
              <label>
                No. of Sessions{" "}
                <div className="tool-tip">
                  <div className="info-icon">
                    <img src={info} alt="info" />
                  </div>
                  <div className="tooltiptext">
                    This is the number of sessions handled on a{" "}
                    {serviceName.split(" ")[0]} basis
                  </div>
                </div>
              </label>
              <div className="input-group  mb-4">
                <input
                  type="number"
                  class="form-control"
                  inputMode="numeric"
                  min="0"
                  // max="9999"
                  id="myNumberInput"
                  name="noOfSessions"
                  {...register(
                    "noOfSessions",
                    addEditServiceValidation.noOfSessions
                  )}
                />
              </div>
              <ErrorMessage errors={errors} errorKey="noOfSessions" />
            </div>
          </div>
        )}
      </div>

      <button class="btn btn-primary btn-reel">
        {isEdit ? "Save" : "Add"}
      </button>
    </form>
  );
};

export default AddEditService;
